/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApVersionGetResponseApiFrom } from '../../models/ap-version-get-response-api-from';

export interface ApiV3ServiceApVersionGetGet$Params {

/**
 * * Interface language
 */
  lang?: string;
}

export function apiV3ServiceApVersionGetGet(http: HttpClient, rootUrl: string, params?: ApiV3ServiceApVersionGetGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ApVersionGetResponseApiFrom>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceApVersionGetGet.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApVersionGetResponseApiFrom>;
    })
  );
}

apiV3ServiceApVersionGetGet.PATH = '/api/v3/service/ApVersionGet';
